<template>

    <div class="tournament-list" style="padding-bottom: 0">
        <!--<div v-if="tournament.isTnmtTimeTablePublic=='N'">-->
        <div>
            <div class="tournament-top-info-wrap">
                <p class="left-wrap">
                    <span>{{getDate(match.matchDate)}}</span>
                    <span class="gym-name">{{match.gymName}}</span>
                </p>
                <p class="right-wrap">
                    <span>{{getTime(match.matchTime)}}</span>
                    <span>{{match.courtId}}코트</span>
                    <span>{{match.courtOrder}}경기</span>
                </p>
            </div>
        </div>
        <div v-if="match.isPlaying==='D'">
            <div class="tournament-wrap">
                <div class="thumbnail" :style="{backgroundImage: `url('${match.thumbnail}')`}" @click="urlBroadCastFunc(match)">
                    <div class="play-btn" v-if="match.broadcastUrl"></div>
                </div>
                <!--경기완료-->
                <div class="tournament-info-wrap">
                    <table>
                        <tr :class="match.winnerParticipantId === match.firstParticipantInfo.participantId ? 'win' : 'lose'">
                            <td class="player-info-wrap">
                                <div class="player-info">
                                    <p class="team" v-if="match.firstParticipantInfo.participantName!=match.firstParticipantInfo.userList[0].playerName">{{match.firstParticipantInfo.participantName}}</p>
                                    <p class="player">
                                        <span v-if="(match.isOpponentRetired === 'W' || match.isOpponentRetired === 'A') && match.winnerParticipantId === match.firstParticipantInfo.participantId" class="label is-opponent-retired ">기권승</span>
                                        <span v-else-if="(match.isOpponentRetired === 'W' || match.isOpponentRetired === 'A') && match.winnerParticipantId !== match.firstParticipantInfo.participantId" class="label is-opponent-retired ">기권패</span>
                                        <span
                                                v-else-if="match.winnerParticipantId === match.firstParticipantInfo.participantId"
                                                class="label">승</span>
                                        <span class="label" v-else>패</span>
                                        <span class="player-name"><span v-for="user in match.firstParticipantInfo.userList">{{user.playerName}} </span></span>
                                    </p>
                                </div>
                            </td>
                            <td class="score-wrap">
                                <div class="score-content">
                                    <p v-for="(score, scoreIndex) in match.setScoreList" :key="`score ${scoreIndex}`"
                                       :class="score.firstParticipantGame > score.secondParticipantGame ?  'win' : 'lose'">
                                        {{score.firstParticipantGame}}</p>
                                </div>
                            </td>
                        </tr>
                        <tr :class="match.winnerParticipantId === match.secondParticipantInfo.participantId ? 'win' : 'lose'">
                            <td class="player-info-wrap">
                                <div class="player-info">
                                    <p class="team" v-if="match.secondParticipantInfo.participantName!=match.secondParticipantInfo.userList[0].playerName">{{match.secondParticipantInfo.participantName}}</p>
                                    <p class="player">
                                        <span v-if="(match.isOpponentRetired === 'W' || match.isOpponentRetired === 'A') && match.winnerParticipantId === match.secondParticipantInfo.participantId" class="label is-opponent-retired ">기권승</span>
                                        <span v-else-if="(match.isOpponentRetired === 'W' || match.isOpponentRetired === 'A') && match.winnerParticipantId !== match.secondParticipantInfo.participantId" class="label is-opponent-retired ">기권패</span>
                                        <span class="label" v-else-if="match.winnerParticipantId === match.secondParticipantInfo.participantId">승</span>
                                        <span class="label" v-else>패</span>
                                        <span class="player-name"><span v-for="user in match.secondParticipantInfo.userList">{{user.playerName}} </span></span>
                                    </p>
                                </div>
                            </td>
                            <td class="score-wrap">
                                <div class="score-content">
                                    <p v-for="(score, scoreIndex) in match.setScoreList" :key="`score ${scoreIndex}`"
                                       :class="score.firstParticipantGame < score.secondParticipantGame ?  'win' : 'lose'">
                                        {{score.secondParticipantGame}}</p>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="team-detail-wrap" v-if="match.tnmtTypeId === 'TEAM'">
                <div class="team-detail-btn-wrap">
                    <p @click="subMatchShow = !subMatchShow" :class="subMatchShow ?  'active' :''">단체전 세부 경기보기</p>
                </div>
                <TeamCompetitionDetail :match_parent="match" v-if="subMatchShow"></TeamCompetitionDetail>

            </div>
        </div>


        <div class="tournament-schedule-wrap" v-else>
            <div class="tournament-schedule">
                <div class="player-info-wrap">
                    <div class="player-info">
                        <p class="participant-name">{{match.firstParticipantInfo.participantName}}</p>
                        <span class="player-name"><span v-for="user in match.firstParticipantInfo.userList">{{user.playerName}} </span></span>
                    </div>
                    <p>경기예정</p>
                </div>
                <div class="player-info-wrap">
                    <div class="player-info">
                        <p class="participant-name">{{match.secondParticipantInfo.participantName}}</p>
                        <span class="player-name"><span v-for="user in match.secondParticipantInfo.userList">{{user.playerName}} </span></span>
                    </div>
                    <p>경기예정</p>
                </div>

            </div>
            <div class="team-detail-wrap" v-if="match.tnmtTypeId === 'TEAM'">
                <div class="team-detail-btn-wrap">
                    <p @click="subMatchShow = !subMatchShow" :class="subMatchShow ?  'active' :''">단체전 세부 경기보기</p>
                </div>
                <TeamCompetitionDetail :match_parent="match" v-if="subMatchShow"></TeamCompetitionDetail>

            </div>
        </div>
    </div>
</template>
<script>
    import TeamCompetitionDetail from './TeamCompetitionDetail'
    export default{
        components:{TeamCompetitionDetail},
        props: ['match'],
        data(){
            return{
                subMatchShow: false
            }
        },
        methods:{

            getDate(date) {
                const year = date.substr(0, 4)
                const month = date.substr(4, 2)
                const day = date.substr(6, 2)

                const week = ['일', '월', '화', '수', '목', '금', '토', '일']

                const datetime = new Date(`${year}-${month}-${day}`)

                return `${month}.${day} ${week[datetime.getDay()]}`
            },
            getTime(time) {
                const hour = time.substr(0, 2)
                const min = time.substr(2, 2)

                return `${hour}:${min}`
            },
            urlBroadCastFunc(match){
                if(match.broadcastUrl){
                    window.open(match.broadcastUrl)
                }
            }
        }
    }
</script>

